import React, { useEffect, useState, useCallback, useRef } from "react";
import { Row, Col, Button, Label, Tooltip, FormGroup, Input } from "reactstrap";
import {
	AvForm,
	AvField,
	AvRadioGroup,
	AvRadio,
} from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import {
	frequencyPropertyOptions,
	frequencyOwnerOptions,
	offPaymentTypeOptions,
} from "Enums/fixedData";
import Select from "react-select";
import "./style.scss";
import CurrencyInput from "react-currency-input-field";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ResaleService from "services/Website/ResaleService";

const StepFive = ({
	setModal,
	goBackHandler,
	id,
	data,
	updateStateHandler,
	loading,
}) => {
	const currentYear = new Date().getFullYear();
	const currentMonth = new Date().getMonth() + 1;
	const AuthData = useSelector((state) => state.Auth);
	const isMounted = useRef(false);
	const [offPaymentOptions, setOffPaymentOptions] = useState(
		offPaymentTypeOptions
	);
	const [tooltipOpen, setTooltipOpen] = useState(false);
	const toggle = () => setTooltipOpen(!tooltipOpen);
	const resaleService = new ResaleService();
	const [offPayment, setOffPayment] = useState(false);
	const [rend, setRend] = useState(false);
	const [paymentAmount, setPaymentAmount] = useState();
	const [change, setChange] = useState();
	const { t } = useTranslation();
	const currency = useSelector((state) => state.Auth?.currency);
	const [error, setError] = useState({
		depost: false,
		total_price: false,
		remaining: false,
	});
	const [formData, setFormData] = useState({
		depost: "",
		total_price: "",
		payment_method: "Cash",
		remaining_price: "",
		paid_price: "",
		original_price: "",
		until_month: "",
		until_year: "",
		years: "",
		down_payment: "",
		payment_amount: "",
		payment_frequency: null,
		recurring_payments: [],
		in_owner_installment: false,
		off_payments: [],
	});

	const handleFieldChange = (e) => {
		if (e.target.name === "payment_method") {
			changePaymentMethod(e.target.value);
		}
		setFormData((formData) => ({
			...formData,
			[e.target.name]: e.target.value,
		}));
	};
	const getOptions = useCallback(
		(lang, list) => {
			return list.map((item) => {
				return {
					...item,
					label: item[`${lang}`],
				};
			});
		},
		[AuthData.lang]
	);

	useEffect(() => {
		if (id) {
			if (data.payment_method === "Cash") {
				setFormData({
					...formData,
					payment_method: "Cash",
					in_owner_installment: false,
					total_price: data.payment_plan.total_price,
					depost: data.payment_plan.depost,
				});
			} else if (data.payment_method === "Installment") {
				setFormData({
					...formData,
					payment_method: "Installment",
					in_owner_installment: false,
					years: data.payment_plan.years[0].years,
					down_payment: data.payment_plan.years[0].down_payment,
					payment_frequency: {
						label:
							data.payment_plan.years[0].recurring_payments[0]
								.payment_frequency,
						value:
							data.payment_plan.years[0].recurring_payments[0]
								.payment_frequency,
					},
					payment_amount:
						data.payment_plan.years[0].recurring_payments[0].payment_amount,
					total_price: data.payment_plan.total_price,
					depost: data.payment_plan.depost,
				});
				getRemaining();
			} else {
				const loaadedData = data.payment_plan.owner_installment;
				setFormData({
					...formData,
					payment_method: "Owner Installment",
					in_owner_installment: true,
					total_price: data.payment_plan.total_price,
					remaining_price: loaadedData?.remaining_price,
					paid_price: loaadedData?.paid_price,
					original_price: loaadedData?.original_price
						? loaadedData?.original_price
						: "",
					until_month: loaadedData?.until_month,
					until_year: loaadedData?.until_year,
					off_payments: loaadedData?.off_payments
						? loaadedData?.off_payments
						: [],
					payment_frequency: {
						label: loaadedData?.recurring_payments[0]?.payment_frequency,
						value: loaadedData?.recurring_payments[0]?.id,
					},
					depost: data.payment_plan.depost,
					recurring_payments: loaadedData?.recurring_payments
						? loaadedData?.recurring_payments
						: [],
				});
				const options = offPaymentTypeOptions.filter(
					(obj1) =>
						!loaadedData?.off_payments.some(
							(payment) => payment.payment_name === obj1.label
						)
				);
				setOffPaymentOptions([...options]);

				setPaymentAmount(
					`${toCurrency(loaadedData?.recurring_payments[0].payment_amount)} ${
						currency?.currency_code
					}`
				);
				// getOwnerPaymentAmount(loaadedData?.remaining_price)
				if (loaadedData?.off_payments.length > 0) {
					setOffPayment(true);
					// loaadedData?.off_payments?.map((item, index) =>{
					//     getOffPaymentAmount({
					//         index: index,
					//         month_number: item?.month_number,
					//         year_number: item?.year_number,
					//         end_month: item?.end_month,
					//         end_year: item?.end_year,
					//         payment_fees: item?.payment_fees,
					//         payment_frequency: item?.payment_frequency
					//     })
					// })
				}
			}
		} else {
			setFormData({ ...formData, ...data });
			setOffPaymentOptions(offPaymentTypeOptions);
			if (data.off_payments?.length > 0) {
				setOffPayment(true);
			}
		}
	}, []);

	const changePaymentMethod = (type) => {
		setFormData((formData) => ({
			...formData,
			remaining_price: "",
			paid_price: "",
			original_price: "",
			until_month: "",
			until_year: "",
			recurring_payments:
				type === "Owner Installment"
					? [{ payment_frequency: "", payment_amount: "" }]
					: [],
			off_payments: type === "Owner Installment" && [],
			years: "",
			down_payment: "",
			payment_amount: "",
			payment_frequency: null,
		}));
		if (type === "Owner Installment") {
			setOffPayment(false);
		}
	};

	const handleValidSubmit = () => {
		if (formData.depost === "0" || !formData.depost || formData.depost === "") {
			setError({ ...error, depost: true });
			return;
		} else if (
			formData.total_price === "0" ||
			!formData.total_price ||
			formData.total_price === ""
		) {
			setError({ ...error, total_price: true });
			return;
		} else if (parseInt(formData?.total_price) < parseFloat(formData.depost)) {
			toast.error(`${t("Total Price must be Bigger Than Deposit")}`);
			return;
		} else {
			let data = {};
			if (formData?.payment_method === "Installment") {
				if (!formData?.payment_frequency) {
					toast.error(`${t("Payemnt frequency required")}`);
					return;
				} else if (
					formData.down_payment === "0" ||
					!formData.down_payment ||
					!formData.down_payment === ""
				) {
					toast.error(
						`${t("Down payment  field required &  doesn't accept zero")}`
					);
					return;
				}
				// else if (parseInt(formData.down_payment) <= parseInt(formData.payment_amount)) {
				//     toast.error(`${t("Down payment must be bigger than payment ammout")}`)
				//     return
				// }
				else if (
					parseInt(formData.down_payment) >= parseFloat(formData.total_price)
				) {
					toast.error(`${t("Total price must be bigger than down payment")}`);
					return;
				} else if (
					parseInt(formData.down_payment) < parseFloat(formData.depost)
				) {
					toast.error(`${t("Down Payment must be Bigger Than Deposit")}`);
					return;
				}

				data = {
					years: parseFloat(formData.years),
					down_payment: parseFloat(formData.down_payment),
					payment_frequency: formData.payment_frequency,
					// in_owner_installment: false,
				};
			} else if (formData.payment_method === "Owner Installment") {
				if (formData.original_price !== "" && formData.original_price < 1) {
					toast.error(`${t("Original price doesn't accept zero")}`);
					return;
				} else if (formData.recurring_payments.length && !validateRecurring()) {
					return;
				} else if (formData.off_payments.length && !validateOffPayment()) {
					return;
				} else if (
					parseFloat(formData.total_price) <= parseFloat(formData.paid_price)
				) {
					toast.error(`${t("Total price must be bigger than down payment")}`);
					return;
				} else if (formData.original_price === "0") {
					toast.error(`${t("Original price doesn't accept zero")}`);
					return;
				} else if (!formData.payment_frequency) {
					toast.error(`${t("Payment Frequency Required")}`);
					return;
				} else if (
					parseFloat(formData.remaining_price) >
					parseFloat(formData.total_price)
				) {
					toast.error(
						`${t("Total Price must be bigger than the Remaining Price")}`
					);
					return;
				} else if (formData.off_payments.length > 0) {
					formData?.off_payments?.map((item, index) => {
						if (item.payment_fees < formData.remaining_price) {
							setError({ ...error, [index]: true });
							return;
						}
					});
					let updatedOffPayments = formData?.off_payments?.map((item) => {
						if (item.payment_name === "Other") {
							return {
								...item,
								payment_name: formData.other_payment_name,
							};
						}
						return item;
					});
					data = {
						remaining_price: parseFloat(formData.remaining_price),
						until_month: formData.until_month,
						until_year: formData.until_year,
						off_payments: updatedOffPayments,
						payment_frequency: formData.payment_frequency,
					};
				} else {
					data = {
						// in_owner_installment: true,
						remaining_price: parseFloat(formData.remaining_price),
						until_month: formData.until_month,
						until_year: formData.until_year,
						off_payments: formData.off_payments,
						payment_frequency: formData.payment_frequency,
					};
				}
				if (
					formData.original_price !== undefined &&
					formData.original_price !== "0" &&
					formData.original_price !== ""
				) {
					data["original_price"] = parseInt(formData.original_price);
				} else {
					data["original_price"] = "";
				}
			}
			updateStateHandler({
				...data,
				total_price: parseFloat(formData.total_price),
				payment_method: formData.payment_method,
				depost: parseFloat(formData.depost),
			});
		}
	};

	const validateRecurring = () => {
		let result = true;
		if (formData.recurring_payments.length !== 0) {
			formData.recurring_payments.forEach((item) => {
				if (
					(item.payment_amount === "0" ||
						item.payment_amount === "" ||
						!item.payment_amount) &&
					formData.payment_method !== "Owner Installment"
				) {
					result = false;
					toast.error(`${t("Payment amount rquired  && doesnot accept zero")}`);
					return;
				} else if (
					item.payment_frequency === "" &&
					formData.payment_method !== "Owner Installment"
				) {
					toast.error(`${t("Payment frequency rquired")}`);
					result = false;
					return;
				} else if (
					parseFloat(formData.total_price) <= parseFloat(item.payment_amount)
				) {
					toast.error(t("Total price must be bigger than payment amount"));
					result = false;
					return;
				}
				// else if (parseFloat(item.payment_amount) >= parseFloat(formData.paid_price)) {
				//     toast.error(" Down Payment must be bigger than payment amount")
				//     result = false
				//     return
				// }
			});
		}
		return result;
	};

	const validateOffPayment = () => {
		let result = true;
		if (formData.off_payments.length !== 0) {
			formData.off_payments.forEach((item) => {
				if (
					item.payment_fees === "0" ||
					item.payment_fees === "" ||
					!item.payment_fees
				) {
					result = false;
					// toast.error(`${t("Payment fees rquired  && doesnot accept zero")}`)
					return;
				} else if (
					parseInt(item.payment_fees) >= parseInt(formData.total_price)
				) {
					result = false;
					// toast.error(`${t("Payment fees must be smaller than total price")}`)
					return;
				}
			});
		}
		return result;
	};

	const getRemaining = () => {
		if (formData.total_price > 0 && formData.down_payment > 0) {
			getPaymentAmount();
			return `${toCurrency(formData.total_price - formData.down_payment)} ${
				currency?.currency_code
			}`;
		} else {
			return "";
		}
	};
	const getPaymentAmount = async () => {
		const dataObj = {
			years: formData.years,
			total_price: formData.total_price,
			down_payment: formData.down_payment,
			payment_frequency: formData.payment_frequency.label,
		};

		if (
			formData.total_price > 0 &&
			formData.down_payment > 0 &&
			formData.years &&
			formData.payment_frequency.label
		) {
			const data = await resaleService.getInstallmentRecurringPayment(
				dataObj,
				"website"
			);
			const res = await data.data;
			setPaymentAmount(`${toCurrency(res)} ${currency?.currency_code}`);
		} else {
			return "";
		}
	};

	const getOwnerPaymentAmount = async (remaining) => {
		const dataObj = {
			until_month: formData.until_month,
			until_year: formData.until_year,
			total_price: formData.total_price,
			remaining_price: remaining,
			payment_frequency: formData.payment_frequency?.label,
		};
		if (
			formData?.total_price > 0 &&
			formData?.remaining_price &&
			formData?.until_month &&
			formData?.until_year &&
			formData?.until_year >= currentYear &&
			formData?.payment_frequency?.label !== "One Shot"
		) {
			resaleService
				?.getOwnerInstallmentRecurringPayment(dataObj, "website")
				.then((res) => {
					setPaymentAmount(
						`${toCurrency(res.data)} ${currency?.currency_code}`
					);
				})
				.catch((e) => console.error(e));
		} else {
			return "";
		}
	};

	useEffect(() => {
		isMounted.current = true;
		if (
			formData.payment_method === "Owner Installment" &&
			formData?.off_payments?.length === 0
		) {
			getOwnerPaymentAmount(formData?.remaining_price);
		}
		if (
			formData.payment_method === "Owner Installment" &&
			formData?.off_payments?.length > 0
		) {
			if (
				formData?.off_payments?.length === 1 &&
				parseInt(formData?.off_payments[0].payment_fees) <
					parseInt(formData.remaining_price)
			) {
				setError({ ...error, remaining: false });
				let sumR =
					parseInt(formData?.remaining_price) -
					parseInt(formData?.off_payments[0].payment_fees);
				getOwnerPaymentAmount(sumR);
			} else {
				setError({ ...error, remaining: true });
			}
			if (formData?.off_payments?.length > 1) {
				let sum = formData?.off_payments?.reduce(
					(a, b) => parseInt(a.payment_fees) + parseInt(b.payment_fees)
				);
				if (parseInt(formData?.remaining_price) > sum) {
					setError({ ...error, remaining: false });
					getOwnerPaymentAmount(parseInt(formData?.remaining_price) - sum);
				} else {
					setError({ ...error, remaining: true });
				}
			}
		}
		return () => (isMounted.current = false);
	}, [
		formData.total_price,
		formData.until_month,
		rend,
		formData.until_year,
		formData.remaining_price,
		formData.payment_frequency?.label,
	]);

	useEffect(() => {
		if (
			formData.total_price > 0 &&
			formData.paid_price > 0 &&
			formData.payment_method === "Installment"
		) {
			setFormData({
				...formData,
				remaining_price: formData.total_price - formData.down_payment,
			});
		}
	}, [formData.total_price, formData.paid_price]);

	const getOffPaymentAmount = async (dataObj) => {
		if (
			parseInt(dataObj.payment_fees) > 0 &&
			dataObj.end_month &&
			dataObj.end_year &&
			dataObj.month_number &&
			dataObj.year_number &&
			dataObj.end_year >= dataObj.year_number &&
			dataObj.payment_frequency !== "One Shot"
		) {
			const data = await resaleService?.getOffPayment(dataObj, "website");
			const res = await data?.data;
			// setOffPaymentAmount([...offPaymentAmount, {[index]: res}])
			// offAmount.push({[index]: res})

			const updatedOffPayments = formData.off_payments?.map(
				(offItem, offIndex) => {
					if (dataObj.index === offIndex) {
						return {
							...offItem,
							payment_amount: res,
						};
					}
					return offItem;
				}
			);
			setFormData({ ...formData, off_payments: [...updatedOffPayments] });
		} else {
			return "";
		}
	};

	useEffect(() => {
		let offItem = formData?.off_payments[change];
		if (
			!!offItem &&
			offItem?.month_number !== "" &&
			!!offItem?.month_number &&
			offItem?.year_number !== "" &&
			!!offItem?.year_number &&
			offItem?.end_month !== "" &&
			!!offItem?.end_month &&
			offItem?.end_year !== "" &&
			!!offItem?.end_year &&
			offItem?.payment_fees !== "" &&
			!!offItem?.payment_fees &&
			offItem?.payment_frequency !== "" &&
			!!offItem?.payment_frequency &&
			parseInt(offItem?.end_year) >= parseInt(offItem?.year_number)
		) {
			getOffPaymentAmount({
				index: change,
				month_number: offItem?.month_number,
				year_number: offItem?.year_number,
				end_month: offItem?.end_month,
				end_year: offItem?.end_year,
				payment_fees: offItem?.payment_fees,
				payment_frequency: offItem?.payment_frequency,
			});
		}
	}, [rend]);

	useEffect(() => {
		if (formData?.off_payments.length > 0) {
			setOffPayment(true);
		}
	}, []);

	const calcMinMonthAndYear = () => {
		if (
			!formData?.until_year ||
			!formData?.until_month ||
			formData?.until_year < currentYear
		) {
			return {
				month: 1,
				year: currentYear,
				monthError: "This Field is Required",
				yearError: "This Field is Required",
			};
		} else if (formData.payment_frequency.label === "One Shot") {
			if (formData?.until_year == currentYear) {
				if (currentMonth + 1 > 11) {
					return {
						month: currentMonth + 1 - 11,
						year: currentYear + 1,
						monthError: "Month Must be bigger than current Month",
						yearError: "Year Must be bigger than current Year",
					};
				} else {
					return {
						month: currentMonth + 1,
						year: currentYear,
						monthError: "Month Must be bigger than current Month",
						yearError: "Year Must be bigger than or Equal current Year",
					};
				}
			} else {
				if (currentMonth + 1 > 11) {
					return {
						month: currentMonth + 1 - 11,
						year: currentYear + 1,
						monthError: "Month Must be bigger than current Month",
						yearError: "Year Must be bigger than current Year",
					};
				} else {
					return {
						month: 1,
						year: currentYear + 1,
						monthError: "Month Must be bigger than current Month",
						yearError: "Year Must be bigger than or Equal current Year",
					};
				}
			}
		} else if (formData.payment_frequency.label === "Monthly") {
			if (formData?.until_year == currentYear) {
				if (currentMonth + 2 > 11) {
					return {
						month: currentMonth + 2 - 11,
						year: currentYear + 1,
						monthError: "Month Must be bigger than current Month",
						yearError: "Year Must be bigger than current Year",
					};
				} else {
					return {
						month: currentMonth + 2,
						year: currentYear,
						monthError: "Month Must be bigger than current Month",
						yearError: "Year Must be bigger than or Equal current Year",
					};
				}
			} else {
				if (currentMonth + 2 > 11) {
					return {
						month: currentMonth + 2 - 11,
						year: currentYear + 1,
						monthError: "Month Must be bigger than current Month",
						yearError: "Year Must be bigger than current Year",
					};
				} else {
					return {
						month: 1,
						year: currentYear + 1,
						monthError: "Month Must be bigger than current Month",
						yearError: "Year Must be bigger than or Equal current Year",
					};
				}
			}
		} else if (formData.payment_frequency.label === "Quarterly") {
			if (formData?.until_year == currentYear) {
				if (currentMonth + 4 > 11) {
					return {
						month: currentMonth + 4 - 11,
						year: currentYear + 1,
						monthError: "Month Must be bigger than Three Months ahead",
						yearError: "Year Must be bigger than current Year",
					};
				} else {
					return {
						month: currentMonth + 4,
						year: currentYear,
						monthError: "Month Must be bigger than Three Months ahead",
						yearError: "Year Must be bigger than or Equal current Year",
					};
				}
			} else {
				if (currentMonth + 4 > 11) {
					return {
						month: currentMonth + 4 - 11,
						year: currentYear + 1,
						monthError: "Month Must be bigger than Three Months ahead",
						yearError: "Year Must be bigger than current Year",
					};
				} else {
					return {
						month: 1,
						year: currentYear + 1,
						monthError: "Month Must be bigger than Three Months ahead",
						yearError: "Year Must be bigger than or Equal current Year",
					};
				}
			}
		} else if (formData.payment_frequency.label === "Semi-Annual") {
			if (formData?.until_year == currentYear) {
				if (currentMonth + 7 > 11) {
					return {
						month: currentMonth + 7 - 11,
						year: currentYear + 1,
						monthError: "Month Must be bigger than Six Months ahead",
						yearError: "Year Must be bigger than Current Year",
					};
				} else {
					return {
						month: currentMonth + 7,
						year: currentYear,
						monthError: "Month Must be bigger than Six Months ahead",
						yearError: "Year Must be bigger than or Equal Current Year",
					};
				}
			} else {
				if (currentMonth + 7 > 11) {
					return {
						month: currentMonth + 7 - 11,
						year: currentYear + 1,
						monthError: "Month Must be bigger than Six Months ahead",
						yearError: "Year Must be bigger than Current Year",
					};
				} else {
					return {
						month: 1,
						year: currentYear,
						monthError: "Month Must be bigger than Six Months ahead",
						yearError: "Year Must be bigger than or Equal Current Year",
					};
				}
			}
		} else if (formData.payment_frequency.label === "Annual") {
			if (currentMonth + 1 > 11) {
				return {
					month: currentMonth + 1 - 11,
					year: currentYear + 1,
					monthError: "Month Must be bigger than current Month",
					yearError: "Year Must be bigger than current Year",
				};
			} else {
				return {
					month: currentMonth + 1,
					year: currentYear + 1,
					monthError: "Month Must be bigger than current Month",
					yearError: "Year Must be bigger than current Year",
				};
			}
		}
	};

	return (
		<AvForm
			onValidSubmit={(e, v) => handleValidSubmit(e, v)}
			className="step-one">
			<p className="subtitle">
				{t("CHOOSE BETWEEN THESE PAYMENT SYSTEMS AND COMPLETE THEIR DATA")}
			</p>
			<Row className="mt-3">
				<Col md={12} className="radio-box mb-3">
					<AvRadioGroup
						className="paymentOptions"
						style={{ maxWidth: "100%", marginLeft: "0", background: "none" }}
						inline
						name="payment_method"
						required
						value={formData.payment_method}
						onChange={handleFieldChange}>
						<AvRadio label={t("Cash")} value="Cash" />
						<AvRadio label={t("Installment with Me")} value="Installment" />
						<AvRadio
							label={t("Rest of Installments with Compound")}
							value="Owner Installment"
						/>
					</AvRadioGroup>
				</Col>
				<Col md={4} className="mb-3 price-input">
					<Label>{t("Deposit")}</Label>
					<CurrencyInput
						id="depost"
						className={
							error.depost && !formData.depost
								? "error-input style-input"
								: "style-input"
						}
						name={"depost"}
						placeholder={t("Deposit")}
						value={formData.depost}
						allowNegativeValue={false}
						decimalsLimit={2}
						required
						onValueChange={(value) => {
							setFormData({ ...formData, depost: value });
							value && setError({ ...error, depost: false });
						}}
					/>
					{error.depost && (
						<p className="error-text">
							{t("Deposit field required &  doesn't accept zero")}
						</p>
					)}
				</Col>
				{!!formData.depost && (
					<Col md={4} className="mb-3 price-input">
						<Label>{t("Total Price")}</Label>
						<CurrencyInput
							id="price"
							className={
								error.total_price &&
								!formData.total_price &&
								formData.total_price !== 0
									? "error-input style-input"
									: "style-input"
							}
							name={"total_price"}
							placeholder={t("price")}
							value={formData.total_price}
							allowNegativeValue={false}
							decimalsLimit={2}
							required
							onValueChange={(value) => {
								setFormData({ ...formData, total_price: value });
								value && setError({ ...error, total_price: false });
							}}
						/>
						{error.total_price && (
							<p className="error-text">
								{t("Total Price field required &  doesn't accept zero")}
							</p>
						)}
					</Col>
				)}
				{formData.payment_method === "Owner Installment" && (
					<>
						{!!formData.depost && (
							<Col md={4} className="mb-3 price-input">
								<Label>{t("Origin Price (Optional)")}</Label>
								<CurrencyInput
									id="price"
									className="style-input"
									name={"original_price"}
									placeholder={t("Origin Price")}
									value={formData.original_price}
									allowNegativeValue={false}
									decimalsLimit={2}
									onValueChange={(value) => {
										setFormData({ ...formData, original_price: value });
									}}
								/>
							</Col>
						)}
						{!!formData.total_price && (
							<Col md={4} className="mb-3 price-input">
								<Label>{t("Remaining Price")}</Label>
								<CurrencyInput
									className={error?.remaining ? "style-input" : "style-input"}
									id="price"
									name={"remaining_price"}
									allowNegativeValue={false}
									decimalsLimit={2}
									value={formData.remaining_price}
									onValueChange={(value) => {
										setFormData({ ...formData, remaining_price: value });
									}}
									placeholder={t("Remaining Price")}
								/>
								{!!error?.remaining && (
									<p className="error-text mb-3">
										{t("Remaining Must be Bigger than the Total Payment Fees")}
									</p>
								)}
							</Col>
						)}

						{!!formData.remaining_price && (
							<>
								<Col md={4} className="mb-3 price-input">
									<Label>{t("Paid Amount")}</Label>
									<CurrencyInput
										id="price"
										className="style-input"
										name={"paid_price"}
										placeholder={t("Paid Amount")}
										value={formData.total_price - formData.remaining_price}
										allowNegativeValue={false}
										decimalsLimit={2}
										disabled={true}
										onValueChange={(value) => {
											setFormData({ ...formData, paid_price: value });
										}}
									/>
								</Col>
								<Col md={4} className="mb-3">
									<label>{t("Payment Frequency")}*</label>
									<Select
										placeholder={t("select")}
										name="payment_frequency"
										value={formData.payment_frequency}
										options={getOptions(AuthData.lang, frequencyOwnerOptions)}
										className="style-input"
										onChange={(data) => {
											setFormData({ ...formData, payment_frequency: data });
										}}
									/>
								</Col>
							</>
						)}
						{!!formData.payment_frequency && (
							<>
								<Col md={4} className="mb-3">
									<AvField
										errorMessage={calcMinMonthAndYear()?.monthError}
										name={"until_month"}
										label={
											formData.payment_frequency.label === "One Shot"
												? t("Month")
												: t("Until Month")
										}
										bsSize="lg"
										required
										className="style-input"
										value={formData.until_month}
										step="1"
										pattern="\d+"
										type="number"
										min={calcMinMonthAndYear()?.month}
										max={"12"}
										onChange={(e) => {
											setFormData({
												...formData,
												until_month: e.target.value,
											});
										}}
										placeholder={
											formData.payment_frequency.label === "One Shot"
												? t("Month")
												: t("Until Month")
										}
									/>
								</Col>

								<Col md={4} className="mb-3">
									<AvField
										errorMessage={calcMinMonthAndYear()?.yearError}
										className="style-input"
										name={"until_year"}
										label={
											formData.payment_frequency.label === "One Shot"
												? t("Year")
												: t("Until Year")
										}
										bsSize="lg"
										required
										value={formData.until_year}
										onChange={(e) => {
											setFormData({
												...formData,
												until_year: e.target.value,
											});
										}}
										placeholder="e.g. 2026"
										type="number"
										step="1"
										pattern="\d+"
										min={calcMinMonthAndYear()?.year}
										max={currentYear + 30}
									/>
								</Col>
							</>
						)}

						{formData.payment_frequency?.label !== "One Shot" &&
							!!formData?.recurring_payments &&
							!!formData.until_year &&
							formData.until_year >= currentYear &&
							!!formData.until_month && (
								<>
									<Col md={4} className="mb-3 price-input">
										<Label>
											{t("Payment Amount for unit")}
											<i
												className="fa ms-2 fa-question-circle"
												id="DisabledAutoHideExample"></i>
											<Tooltip
												placement="bottom"
												isOpen={tooltipOpen}
												autohide={false}
												target="DisabledAutoHideExample"
												toggle={toggle}>
												This field displays the amount paid for unit
												installments only based on the selected Payment
												Frequency, and the value in the field will decrease in
												each addition of another payment plan type
											</Tooltip>
										</Label>
										<AvField
											id={`payment_amount`}
											className="style-input"
											name={`Payment Amount`}
											placeholder={t("Payment Amount")}
											onChange={() =>
												getOwnerPaymentAmount(formData.remaining_price)
											}
											value={paymentAmount}
											readOnly
										/>
									</Col>
								</>
							)}
						{/* {formData.payment_frequency && ( */}
						{true && (
							<Row className="m-0 p-0 box-container mt-3">
								<Col md={6} className="my-4 overflow-hidden">
									<h3
										className="m-0 fw-bold text-primary"
										dangerouslySetInnerHTML={{
											__html: t("Additional Payment Plan Type"),
										}}></h3>
								</Col>
								<Col
									md={4}
									className="mb-3 d-flex flex-row-reverse overflow-hidden">
									<div className="form-check form-switch form-switch-md mt-3">
										<FormGroup check>
											<Input
												id="exampleCheck"
												name="check"
												type="checkbox"
												style={{ left: "8px" }}
												className="mt-1"
												checked={offPayment}
												onChange={(e) => {
													setOffPayment(e.target.checked);
													if (
														e.target.checked &&
														formData.off_payments.length === 0
													) {
														setFormData({
															...formData,
															off_payments: [
																{
																	payment_name: "",
																	payment_fees: "",
																	year_number: "",
																	month_number: "",
																},
															],
														});
													}
													if (e.target.checked === false) {
														setFormData({ ...formData, off_payments: [] });
													}
												}}
												// value={offPayment}
											/>
										</FormGroup>
									</div>
								</Col>
							</Row>
						)}
						{/* {offPayment && <Row className="my-3 mx-2 py-2 bg-light" >
                                <Col md={12} className="my-2"><h5> 1 {t("One-Off Payment")}</h5></Col>
                                
                                <Col md={4} >
                                <label>{t("Payment Plan")}*</label>
                                <Select
                                    placeholder={t("select")}
                                    name= 'offpayments_fayment_name'
                                    value={formData.off_payments?.payment_frequency}
                                    options={getOptions(AuthData.lang, offPaymentTypeOptions)}
                                    className='mb-3 '
                                    onChange={e => {
                                        const updatedOffPayments = formData.off_payments.map((offItem, offIndex) => {
                                            if (offIndex === 0) {
                                                return {
                                                    ...offItem,
                                                    payment_frequency: e.value
                                                }
                                            }
                                            return offItem
                                        })
                                        setFormData({ ...formData, off_payments: [...updatedOffPayments] })
                                    }}
                                />
                                </Col>
                                <Col md={4}>
                                <label>{t("Payment Frequency")}*</label>
                                <Select
                                    placeholder={t("select")}
                                    name= 'payment_frequency'
                                    value={formData.off_payments?.pay}
                                    options={getOptions(AuthData.lang, frequencyOwnerOptions)}
                                    className='mb-3 '
                                    onChange={e => {
                                        const value = e.label
                                        const updatedOffPayments = formData.off_payments.map((offItem, offIndex) => {
                                            if (offIndex === 0) {
                                                return {
                                                    ...offItem,
                                                    payment_name: value
                                                }
                                            }
                                            return offItem
                                        })
                                        setFormData({ ...formData, off_payments: [...updatedOffPayments] })
                                    }}
                                />
                            </Col>
                                
                            </Row>} */}

						{/*formData ?.recurring_payments ?.length ? formData ?.recurring_payments ?.map((recurringPayment, recurringIndex) => {
                        return (
                            <Row className="my-3 mx-2 py-2 bg-light" key={recurringIndex}>
                                <Row className="pt-2 ">
                                    <Col md={4}>
                                        <h5>{t("Recurring Payment")}</h5>
                                    </Col>

                                  //  { <Col md={4} className="d-flex justify-content-end my-2">
                                        <button
                                            className="btn btn-light text-danger fw-bold"
                                            type="button"
                                            onClick={() => {
                                                const updatedList = formData.recurring_payments.filter((recurringItem, itemIndex) => itemIndex !== recurringIndex)
                                                setFormData({ ...formData, recurring_payments: [...updatedList] })
                                            }}
                                        >
                                            X
                                                                </button>
                                   // </Col> }
                                </Row>
                                <Col md={4} className="price-input"  >
                                    <Label>{t("Payment Amount")}*</Label>
                                    <CurrencyInput
                                        id={`payment_amount${recurringIndex}`}
                                        className="mb-3 style-input"
                                        name={`payment_amount${recurringIndex}`}
                                        placeholder={t("Payment Amount")}
                                        value={recurringPayment.payment_amount}
                                        allowNegativeValue={false}
                                        decimalsLimit={2}
                                        required
                                        onValueChange={(value, name) => {
                                            const updatedList = formData.recurring_payments.map((recurringItem, itemIndex) => {
                                                if (recurringIndex === itemIndex) {
                                                    return {
                                                        ...recurringItem,
                                                        payment_amount: value
                                                    }
                                                } else {
                                                    return recurringItem
                                                }
                                            })
                                            setFormData({ ...formData, recurring_payments: [...updatedList] })
                                        }}
                                    />

                                </Col>
                            </Row>
                        )
                    })
                        : null */}
						{/* {formData ?.recurring_payments ?.length < 2 && <Col className="d-flex justify-content-end my-2 mx-2">
                        <button
                            className="btn btn-light"
                            type="button"
                            onClick={() => {

                                setFormData({ ...formData, recurring_payments: [...formData.recurring_payments, { payment_frequency: "", payment_amount: "" }] })
                            }}
                        >
                            {t("Add New Recurring")}
                        </button>
                    </Col>} */}
						{offPayment
							? formData?.off_payments?.map((offItem, offParentIndex) => {
									const selectOptions = getOptions(AuthData.lang, [
										...offPaymentOptions,
										{
											label: "Other",
											en: "Other",
											ar: "اخرى",
											zh: "其他",
											ru: "Другой",
											value: "Other",
										},
									]);
									const frequencySelectOptions = getOptions(
										AuthData.lang,
										frequencyOwnerOptions
									);
									return (
										<Row
											className="mt-3 py-2"
											key={offParentIndex}
											style={{
												borderRadius: "25px",
												background: "var(--bg-color)",
											}}>
											<Col md={offParentIndex === 0 ? 12 : 6} className="my-2">
												<label className="fw-bold mt-3">
													{offParentIndex + 1}
													{offParentIndex + 1 === 1 && "st"}
													{offParentIndex + 1 === 2 && "nd"}
													{offParentIndex + 1 === 3 && "rd"}
													{offParentIndex + 1 > 3 && "th"}
													{t(" Payment Plan Type")}
												</label>
											</Col>
											{offParentIndex > 0 && (
												<Col md={6} className="d-flex justify-content-end my-2">
													<button
														className="btn btn-light h-42"
														type="button"
														onClick={() => {
															const updatedOffPayments =
																formData.off_payments.filter(
																	(_, index) => index !== offParentIndex
																);
															setFormData({
																...formData,
																off_payments: [...updatedOffPayments],
															});
														}}
														style={{
															color: "#fff",
															background: "var(--primary-color)",
															fontWeight: "700",
														}}>
														X
													</button>
												</Col>
											)}
											<Col md={4}>
												<label>{t("Payment Name")}*</label>
												<Select
													className="mb-3"
													placeholder={t("Select")}
													options={selectOptions}
													value={
														!!selectOptions[
															selectOptions.findIndex(
																(item) => item.value == offItem?.payment_name
															)
														]
															? selectOptions[
																	selectOptions.findIndex(
																		(item) =>
																			item.value == offItem?.payment_name
																	)
															  ]
															: !!offItem?.payment_name
															? {
																	label: offItem?.payment_name,
																	value: offItem?.payment_name,
															  }
															: null
													}
													onChange={(e) => {
														const updatedOffPayments =
															formData.off_payments.map((offItem, offIndex) => {
																if (offParentIndex === offIndex) {
																	return {
																		...offItem,
																		payment_name: e.value,
																	};
																}
																return offItem;
															});
														setFormData({
															...formData,
															off_payments: [...updatedOffPayments],
														});
														setOffPaymentOptions(
															offPaymentOptions.filter(
																(option) => e.value !== option.value
															)
														);
													}}
													required
												/>
											</Col>
											{offItem?.payment_name === "Other" && (
												<Col md={4}>
													<label>{t("Name")}*</label>
													<AvField
														errorMessage={t("this field is required")}
														className="mb-3 style-input"
														name="payment_name"
														bsSize="lg"
														value={formData.other_payment_name}
														onBlur={(e) =>
															setFormData({
																...formData,
																other_payment_name: e.target.value,
															})
														}
														required
														type="text"
														placeholder={t("Payment Name")}
													/>
												</Col>
											)}
											<Col md={4} className="price-input">
												<Label
													className={`${
														error[offParentIndex] && "error-text"
													}`}>
													{t("Payment Fees")}*
												</Label>
												<CurrencyInput
													id={`Payment fees`}
													errorMessage={t("this field is required")}
													className={`${
														error[offParentIndex] ? "mb-0" : "mb-3"
													} style-input`}
													name={`Payment fees`}
													placeholder={t("Payment Fees")}
													value={offItem.payment_fees}
													min="0"
													max={formData.remaining_price}
													allowNegativeValue={false}
													decimalsLimit={2}
													required
													onValueChange={(value, name) => {
														setRend(!rend);
														setChange(offParentIndex);
														const updatedOffPayments =
															formData.off_payments.map((offItem, offIndex) => {
																if (offParentIndex === offIndex) {
																	return {
																		...offItem,
																		payment_fees: value,
																	};
																}
																return offItem;
															});
														setFormData({
															...formData,
															off_payments: [...updatedOffPayments],
														});
														if (
															parseInt(value) >=
															parseInt(formData.remaining_price)
														) {
															setError({ ...error, [offParentIndex]: true });
														} else {
															setError({ ...error, [offParentIndex]: false });
														}
													}}
												/>
												{error[offParentIndex] && (
													<p className="error-text mb-3">
														{t("Must be Smaller than the Remaining Price")}
													</p>
												)}
											</Col>
											<Col md={4}>
												<label>{t("Payment Frequency")}*</label>
												<Select
													className="mb-3"
													name={`payment_frequency${offParentIndex}`}
													placeholder={t("Select")}
													options={frequencySelectOptions}
													value={
														offItem.payment_frequency
															? frequencySelectOptions[
																	frequencySelectOptions.findIndex(
																		(item) =>
																			item.value == offItem.payment_frequency
																	)
															  ]
															: null
													}
													onChange={(e) => {
														setRend(!rend);
														setChange(offParentIndex);
														const value = e.value;
														const updatedOffPayments =
															formData.off_payments.map((offItem, offIndex) => {
																if (offParentIndex === offIndex) {
																	return {
																		...offItem,
																		payment_frequency: value,
																	};
																}
																return offItem;
															});
														setFormData({
															...formData,
															off_payments: [...updatedOffPayments],
														});
													}}
													required
												/>
											</Col>
											<Col md={2}>
												<AvField
													errorMessage={t("this field is required")}
													className="mb-3 style-input"
													name={`month_number${offParentIndex}`}
													label={
														offItem.payment_frequency === "One Shot"
															? t("Month")
															: t("Start Month")
													}
													bsSize="lg"
													value={offItem.month_number}
													onChange={(e) => {
														setRend(!rend);
														setChange(offParentIndex);
														const value = e.target.value;
														const updatedOffPayments =
															formData.off_payments.map((offItem, offIndex) => {
																if (offParentIndex === offIndex) {
																	return {
																		...offItem,
																		month_number: value,
																	};
																}
																return offItem;
															});
														setFormData({
															...formData,
															off_payments: [...updatedOffPayments],
														});
													}}
													required
													type="number"
													step="1"
													pattern="\d+"
													placeholder={t("Month Number")}
													min={
														offItem.payment_frequency === "One Shot" ||
														parseInt(offItem.year_number) === currentYear
															? currentMonth + 1
															: "1"
													}
													max="12"
												/>
											</Col>
											<Col md={2}>
												<AvField
													errorMessage={t("this field is required")}
													className="mb-3 style-input"
													label={
														offItem.payment_frequency === "One Shot"
															? t("Year")
															: t("Start Year")
													}
													name={`year_number${offParentIndex}`}
													bsSize="lg"
													value={offItem.year_number}
													onChange={(e) => {
														setRend(!rend);
														setChange(offParentIndex);
														const value = e.target.value;
														const updatedOffPayments =
															formData.off_payments.map((offItem, offIndex) => {
																if (offParentIndex === offIndex) {
																	return {
																		...offItem,
																		year_number: value,
																	};
																}
																return offItem;
															});
														setFormData({
															...formData,
															off_payments: [...updatedOffPayments],
														});
													}}
													required
													type="number"
													step="1"
													pattern="\d+"
													placeholder={t("Year Number")}
													min={currentYear}
													max={currentYear + 30}
												/>
											</Col>
											{!!offItem.payment_frequency &&
												offItem.payment_frequency !== "One Shot" && (
													<>
														<Col md={2}>
															<AvField
																errorMessage={
																	parseInt(offItem.year_number) ===
																	parseInt(offItem.end_year)
																		? "Month must be greater than current Month"
																		: t("this field is required")
																}
																className="mb-3 style-input"
																name={`end_month${offParentIndex}`}
																label={`${t("End Month")}*`}
																bsSize="lg"
																value={offItem.end_month}
																onChange={(e) => {
																	setRend(!rend);
																	setChange(offParentIndex);
																	const value = e.target.value;
																	const updatedOffPayments =
																		formData.off_payments.map(
																			(offItem, offIndex) => {
																				if (offParentIndex === offIndex) {
																					return {
																						...offItem,
																						end_month: value,
																					};
																				}
																				return offItem;
																			}
																		);
																	setFormData({
																		...formData,
																		off_payments: [...updatedOffPayments],
																	});
																}}
																required
																type="number"
																step="1"
																pattern="\d+"
																placeholder={t("Month Number")}
																min={
																	parseInt(offItem.year_number) ===
																	parseInt(offItem.end_year)
																		? currentMonth + 1
																		: "1"
																}
																max="12"
															/>
														</Col>
														<Col md={2}>
															<AvField
																errorMessage={
																	offItem.end_year < currentYear
																		? "Year must be after the current year"
																		: t("this field is required")
																}
																className="mb-3 style-input"
																label={`${t("End Year")}*`}
																name={`end_year${offParentIndex}`}
																bsSize="lg"
																value={offItem.end_year}
																onChange={(e) => {
																	setRend(!rend);
																	setChange(offParentIndex);
																	const value = e.target.value;
																	const updatedOffPayments =
																		formData.off_payments.map(
																			(offItem, offIndex) => {
																				if (offParentIndex === offIndex) {
																					return {
																						...offItem,
																						end_year: value,
																					};
																				}
																				return offItem;
																			}
																		);
																	setFormData({
																		...formData,
																		off_payments: [...updatedOffPayments],
																	});
																}}
																required
																type="number"
																step="1"
																pattern="\d+"
																placeholder={t("End Year")}
																min={currentYear}
																max={currentYear + 30}
															/>
														</Col>
														{offItem.end_year &&
															offItem.end_month &&
															offItem.year_number &&
															offItem.month_number &&
															offItem.end_year >= offItem.year_number && (
																<Col md={4} className="price-input">
																	<Label>{`Payment Amount (${offItem.payment_name})`}</Label>
																	<CurrencyInput
																		id={`payment_amount_${offParentIndex}`}
																		name={`Payment Amount (${offItem.payment_name})`}
																		value={offItem.payment_amount}
																		min="0"
																		className="style-input"
																		allowNegativeValue={false}
																		decimalsLimit={2}
																		readOnly
																	/>
																</Col>
															)}
													</>
												)}
										</Row>
									);
							  })
							: null}
						{offPayment && (
							<Row>
								<Col className="d-flex flex-row-reverse my-4">
									<button
										type="button"
										style={{
											borderRadius: "5px",
											borderColor: "var(--primary-color)",
											background: "var(--primary-color)",
										}}
										className="btn btn-success next btnHeight text-center"
										onClick={() => {
											setFormData({
												...formData,
												off_payments: [
													...formData.off_payments,
													{
														payment_name: "",
														payment_fees: "",
														year_number: "",
														month_number: "",
													},
												],
											});
										}}>
										{t("Add Another Payment Type")}
									</button>
								</Col>
							</Row>
						)}
					</>
				)}
				{formData.payment_method === "Installment" && (
					<>
						{!!formData.total_price && (
							<Col md={4} className="price-input">
								<Label>{t("Down Payment")}*</Label>
								<CurrencyInput
									id={`down_payment`}
									className="mb-3 style-input"
									name={`down_payment`}
									placeholder={t("Down Payment")}
									value={formData.down_payment}
									allowNegativeValue={false}
									decimalsLimit={2}
									required
									onValueChange={(value, name) => {
										setFormData({ ...formData, down_payment: value });
									}}
								/>
							</Col>
						)}
						{!!formData.down_payment && (
							<>
								<Col md={4}>
									<AvField
										errorMessage={t("this field is required")}
										className="mb-3 style-input"
										name={`years`}
										label={`${t("Years Of Installment")}*`}
										bsSize="lg"
										value={formData.years}
										onChange={(e) => handleFieldChange(e)}
										required
										placeholder={`${t("Years")} 1-30`}
										min="1"
										type="number"
										max="30"
									/>
								</Col>
								<Col md={4}>
									<label>{t("Payment Frequency")}*</label>
									<Select
										placeholder={t("select")}
										value={formData.payment_frequency}
										options={getOptions(
											AuthData.lang,
											frequencyPropertyOptions
										)}
										className="mb-3 "
										onChange={(data) => {
											setFormData({ ...formData, payment_frequency: data });
										}}
									/>
								</Col>
							</>
						)}
						{!!formData.years &&
							formData.payment_frequency &&
							formData.total_price > 0 &&
							formData.down_payment > 0 && (
								<>
									<Col md={4}>
										<AvField
											className="mb-3 style-input"
											name={"Remaining Price"}
											label={t("Remaining Price")}
											bsSize="lg"
											required
											value={getRemaining()}
											placeholder={t("Remaining Price")}
											type="text"
											disabled={true}
										/>
									</Col>
									<Col md={4} className="price-input">
										<Label>{t("Payment Amount")}</Label>
										<AvField
											id={`payment_amount`}
											className="mb-3 style-input"
											name={`Payment Amount`}
											placeholder={t("Payment Amount")}
											value={paymentAmount}
											disabled={true}
										/>
									</Col>
								</>
							)}
					</>
				)}
			</Row>

			<Row className="my-4">
				<Col md={9}>
					<button
						type="button"
						style={{ borderRadius: "5px", width: "15%" }}
						className="btn btn-light btnHeight cancel text-center "
						onClick={() => setModal(true)}>
						{t("Cancel")}
					</button>
				</Col>
				<Col md={3} className="d-flex justify-content-between">
					<button
						type="button"
						onClick={() => {
							let data =
								formData?.payment_method === "Installment"
									? {
											years: parseFloat(formData?.years),
											down_payment: parseFloat(formData?.down_payment),
											payment_frequency: formData?.payment_frequency,
									  }
									: formData?.payment_method === "Owner Installment"
									? {
											remaining_price: parseFloat(formData?.remaining_price),
											until_month: formData?.until_month,
											until_year: formData?.until_year,
											off_payments:
												formData.off_payments.length > 0
													? formData?.off_payments?.map((item) => {
															if (item.payment_name === "Other") {
																return {
																	...item,
																	payment_name: formData.other_payment_name,
																};
															}
															return item;
													  })
													: formData?.off_payments,
											payment_frequency: formData?.payment_frequency,
									  }
									: {};
							updateStateHandler({
								...data,
								total_price: parseFloat(formData?.total_price),
								payment_method: formData?.payment_method,
								depost: parseFloat(formData?.depost),
							});
							goBackHandler();
						}}
						className="btn btn-light btnHeight back text-center"
						style={{ borderRadius: "5px", width: "45%" }}>
						{t("Back")}
					</button>
					<button
						type="submit"
						style={{
							borderRadius: "5px",
							width: "45%",
							borderColor: "var(--primary-color)",
							background: "var(--primary-color)",
						}}
						className="btn btn-success next btnHeight text-center">
						{t("Next")}
					</button>
				</Col>
			</Row>
		</AvForm>
	);
};

const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};

export default StepFive;
